var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "affiliate-main-sect" }, [
        _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "row justify-content-between" }, [
            _vm._m(1),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "col-lg-5 d-flex flex-wrap d-lg-block align-items-center"
              },
              [
                _c("div", { staticClass: "img__blck" }, [
                  _c("div", { staticClass: "img__blck__info" }, [
                    _vm._v(
                      "\n                            Fully responsive\n                        "
                    )
                  ]),
                  _vm._v(" "),
                  _vm._m(2),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "widjet-compare" },
                    [_vm._m(3), _vm._v(" "), _c("widgetCompare")],
                    1
                  ),
                  _vm._v(" "),
                  _vm._m(4)
                ]),
                _vm._v(" "),
                _vm._m(5)
              ]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _vm._m(6),
      _vm._v(" "),
      _vm._m(7),
      _vm._v(" "),
      _vm._m(8),
      _vm._v(" "),
      _c("review", { attrs: { bgColor: "bg-color" } }),
      _vm._v(" "),
      _c("faq-new", { attrs: { background: "bg-img bg-white" } })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "step-sect affiliate" }, [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "row justify-content-center" }, [
          _c("div", { staticClass: "col-lg-6 col-md-10" }, [
            _c("div", { staticClass: "step_list" }, [
              _c("div", { staticClass: "step_item" }, [
                _c("p", { staticClass: "min p-bold" }, [
                  _vm._v("Become a partner")
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "step_item" }, [
                _c("div", { staticClass: "success-item" })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "step_item" }, [
                _c("p", { staticClass: "min p-bold" }, [_vm._v("Advertise")])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "step_item" }, [
                _c("div", { staticClass: "success-item" })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "step_item" }, [
                _c("p", { staticClass: "min p-bold" }, [_vm._v("Earn")])
              ])
            ])
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-lg-6" }, [
      _c("div", { staticClass: "title" }, [
        _c("h1", { staticClass: "p-title relawayBold p-black mb-0" }, [
          _vm._v("TecknaEl Affiliate")
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "desk" }, [
        _c("p", { staticClass: "p-bold mb-0" }, [
          _vm._v(
            "Want to connect your digital platform to a top-notch affiliate network? With TecknaEl Affiliate you can make money on your website while giving your visitors more functionality"
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "tools" }, [
        _c("p", { staticClass: "min-med p-black p-bold" }, [
          _vm._v("Tools we offer:")
        ]),
        _vm._v(" "),
        _c("ul", [
          _c("li", [_vm._v("Easy to implement widgets (just copy the link)")]),
          _vm._v(" "),
          _c("li", [
            _vm._v("Banners of several sizes (use ours or create your own)")
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "Affilaite dahboard to track your progress or signed contract live"
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v("Two ways of earning (per signed contract or per click)")
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "btns" }, [
        _c("button", { staticClass: "btn btn-green" }, [
          _vm._v("Mail us "),
          _c("img", {
            attrs: { src: require("../../../img/icon/envelope.svg"), alt: "" }
          })
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "right-arrow" }, [
      _c("img", {
        attrs: {
          src: require("../../../img/affiliate/right-arrow.svg"),
          alt: ""
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [
      _c("p", { staticClass: "p-bold p-black p-center" }, [
        _vm._v("SignEl widget")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "down-arrow" }, [
      _c("img", {
        attrs: {
          src: require("../../../img/affiliate/down-arrow.svg"),
          alt: ""
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "link-example" }, [
      _c("p", { staticClass: "p-black p-bold p-center" }, [
        _vm._v("Affiliate link example")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "blk" }, [
        _c("p", [
          _c("span", [_vm._v("<")]),
          _vm._v('a href="'),
          _c("span", { staticClass: "p-blue" }, [
            _vm._v("https://tecknael.se?affiliate=dsdsfjo")
          ]),
          _vm._v('"'),
          _c("span", [_vm._v(">")]),
          _c("span", { staticClass: "p-green" }, [_vm._v("YOUR OWN LINK")]),
          _c("span", [_vm._v("<")]),
          _vm._v("a"),
          _c("span", [_vm._v(">")])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "affiliate-partner-sect" }, [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "row justify-content-between" }, [
          _c("div", { staticClass: "col-md-12" }, [
            _c("div", { staticClass: "title" }, [
              _c("p", { staticClass: "p-title relawayBold p-black mb-0" }, [
                _vm._v("Why partner up with TecknaEl?")
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-lg-4 col-md-6" }, [
            _c("div", { staticClass: "partner__blck" }, [
              _c("div", { staticClass: "img" }, [
                _c("img", {
                  attrs: {
                    src: require("../../../img/affiliate/transparency.svg"),
                    alt: ""
                  }
                })
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "min-med p-black p-bold" }, [
                _vm._v("Transparent")
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor ut labore et dolore magna aliqua"
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-lg-4 col-md-6" }, [
            _c("div", { staticClass: "partner__blck" }, [
              _c("div", { staticClass: "img" }, [
                _c("img", {
                  attrs: {
                    src: require("../../../img/affiliate/Widgets.svg"),
                    alt: ""
                  }
                })
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "min-med p-black p-bold" }, [
                _vm._v("Widgets")
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor ut labore et dolore magna aliqua"
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-lg-4 col-md-6" }, [
            _c("div", { staticClass: "partner__blck" }, [
              _c("div", { staticClass: "img" }, [
                _c("img", {
                  attrs: {
                    src: require("../../../img/affiliate/Dashboard.svg"),
                    alt: ""
                  }
                })
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "min-med p-black p-bold" }, [
                _vm._v("Dashboard")
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor ut labore et dolore magna aliqua"
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-lg-4 col-md-6" }, [
            _c("div", { staticClass: "partner__blck" }, [
              _c("div", { staticClass: "img" }, [
                _c("img", {
                  attrs: {
                    src: require("../../../img/affiliate/responsive.svg"),
                    alt: ""
                  }
                })
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "min-med p-black p-bold" }, [
                _vm._v("Easy to integrate, fully responsive")
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor ut labore et dolore magna aliqua"
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-lg-4 col-md-6" }, [
            _c("div", { staticClass: "partner__blck" }, [
              _c("div", { staticClass: "img" }, [
                _c("img", {
                  attrs: {
                    src: require("../../../img/affiliate/cellphone.svg"),
                    alt: ""
                  }
                })
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "min-med p-black p-bold" }, [
                _vm._v("Easy to contact with us")
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor ut labore et dolore magna aliqua"
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-lg-4 col-md-6" }, [
            _c("div", { staticClass: "partner__blck" }, [
              _c("div", { staticClass: "img" }, [
                _c("img", {
                  attrs: {
                    src: require("../../../img/affiliate/Widgets_2.svg"),
                    alt: ""
                  }
                })
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "min-med p-black p-bold" }, [
                _vm._v("Easy to implement")
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor ut labore et dolore magna aliqua"
                )
              ])
            ])
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "affiliate-abouttools-sect" }, [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "row justify-content-between" }, [
          _c("div", { staticClass: "col-md-12" }, [
            _c("div", { staticClass: "title" }, [
              _c("p", { staticClass: "p-title relawayBold p-black mb-0" }, [
                _vm._v("About our tools in details")
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row aff-row" }, [
          _c("div", { staticClass: "col-lg-6 img-col" }, [
            _c("div", { staticClass: "img" }, [
              _c("img", {
                attrs: {
                  src: require("../../../img/affiliate/01.svg"),
                  alt: ""
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-lg-6 d-flex align-items-center content-col" },
            [
              _c("div", { staticClass: "aff-content" }, [
                _c("p", { staticClass: "relawaySM p-black max-max" }, [
                  _vm._v("Easy to implement widgets ")
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "Through SignEl Affiliate, you can choose to integrate a SignEl widget directly into your platform. Just add this tag:"
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "blk" }, [
                  _c("p", [
                    _c("span", [_vm._v("<")]),
                    _vm._v('iframe src="'),
                    _c("span", { staticClass: "p-blue" }, [
                      _vm._v(
                        "https://tecknael.se/widget/0e833b80-b2d5-11e9-8823-0f577d92280c"
                      )
                    ]),
                    _vm._v('"'),
                    _c("span", [_vm._v(' scrolling="no">')]),
                    _c("span", [_vm._v("<")]),
                    _vm._v("a"),
                    _c("span", [_vm._v(">")])
                  ])
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "This allows visitors to compare their electricity contracts through TecknaEl, completely free of charge. In addition to this, your visitors can easily find the right electricity contract for them, and you can also make money. You can learn more about widget integration on the\n                            "
                  ),
                  _c("a", { attrs: { href: "#" } }, [_vm._v("Documentation")]),
                  _vm._v(" page.")
                ])
              ])
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row aff-row" }, [
          _c(
            "div",
            { staticClass: "col-lg-6 d-flex align-items-center content-col" },
            [
              _c("div", { staticClass: "aff-content" }, [
                _c("p", { staticClass: "relawaySM p-black max-max" }, [
                  _vm._v(
                    "Affilaite dahboard to track your progress & adapt your widget "
                  )
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "Drawing El Affiliate knows that many of our interested partners place great emphasis on comfortable aesthetics. We therefore adapt your widget to your graphic profile and wishes - but if you would like to change this on your own, you are given the tools for it on our DrawEl Affiliate control panel. There you can also monitor the traffic you drive, as well as see the conversion rate of your visitors."
                  )
                ])
              ])
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "col-lg-6 img-col" }, [
            _c("div", { staticClass: "img" }, [
              _c("img", {
                attrs: {
                  src: require("../../../img/affiliate/03.png"),
                  alt: ""
                }
              })
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row aff-row" }, [
          _c("div", { staticClass: "col-lg-6 img-col" }, [
            _c("div", { staticClass: "img" }, [
              _c("img", {
                attrs: {
                  src: require("../../../img/affiliate/02.svg"),
                  alt: ""
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-lg-6 d-flex align-items-center content-col" },
            [
              _c("div", { staticClass: "aff-content" }, [
                _c("p", { staticClass: "relawaySM p-black max-max" }, [
                  _vm._v("Two ways of earning Per signed contract or per click")
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "SignEl Affiliate offers you the choice to either get paid on a “pay-per-click” or “pay-per-order” basis. Pay-per-click means you get paid a small amount for each person who clicks on your TecknaEl widget to compare electricity prices. Pay-per-order means you get paid a larger sum for each person who performs an electricity exchange through TecknaEl after using your widget."
                  )
                ])
              ])
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row aff-row" }, [
          _c(
            "div",
            { staticClass: "col-lg-6 d-flex align-items-center content-col" },
            [
              _c("div", { staticClass: "aff-content" }, [
                _c("p", { staticClass: "relawaySM p-black max-max" }, [
                  _vm._v(
                    "Affilaite dahboard to track your progress & adapt your widget "
                  )
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "Drawing El Affiliate knows that many of our interested partners place great emphasis on comfortable aesthetics. We therefore adapt your widget to your graphic profile and wishes - but if you would like to change this on your own, you are given the tools for it on our DrawEl Affiliate control panel. There you can also monitor the traffic you drive, as well as see the conversion rate of your visitors."
                  )
                ])
              ])
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "col-lg-6 img-col" }, [
            _c("div", { staticClass: "banner__blck" }, [
              _c("div", { staticClass: "p-center" }, [
                _c("img", {
                  attrs: {
                    src: require("../../../img/header/logo.svg"),
                    alt: ""
                  }
                }),
                _vm._v(" "),
                _c("p", { staticClass: "relawaySM max-max p-black" }, [
                  _vm._v("TecknaEl banner example")
                ])
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-12" }, [
            _c("div", { staticClass: "btns" }, [
              _c("button", { staticClass: "btn btn-green" }, [
                _vm._v("Mail us "),
                _c("img", {
                  attrs: {
                    src: require("../../../img/icon/envelope.svg"),
                    alt: ""
                  }
                })
              ])
            ])
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "affiliate-download-sect" }, [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "row justify-content-between" }, [
          _c("div", { staticClass: "col-md-12" }, [
            _c("div", { staticClass: "title" }, [
              _c("p", { staticClass: "p-title relawayBold p-black mb-0" }, [
                _vm._v("Download banners")
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "banners-list" }, [
          _c("div", { staticClass: "banner-item" }, [
            _c("div", { staticClass: "banner-xl banner" }, [
              _c("p", { staticClass: "max-max relawaySM p-center mb-0" }, [
                _vm._v("970х90 banner")
              ])
            ]),
            _vm._v(" "),
            _c("button", { staticClass: "btn btn-blue small" }, [
              _vm._v("Download")
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "banner-item" }, [
            _c("div", { staticClass: "banner-m banner" }, [
              _c("p", { staticClass: "max-max relawaySM p-center mb-0" }, [
                _vm._v("728х90 banner")
              ])
            ]),
            _vm._v(" "),
            _c("button", { staticClass: "btn btn-blue small" }, [
              _vm._v("Download")
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "banner-item" }, [
            _c("div", { staticClass: "banner-s banner" }, [
              _c("p", { staticClass: "max-max relawaySM p-center mb-0" }, [
                _vm._v("300x250 bannerr")
              ])
            ]),
            _vm._v(" "),
            _c("button", { staticClass: "btn btn-blue small" }, [
              _vm._v("Download")
            ])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }